module.exports = __webpack_public_path__ + "static/media/comment-image.cdc31cf2.svg";